export default __webpack_public_path__ + "e6caeaa2fb380060ae7a7113e7013a28.png";